import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component ensures all navigation to new pages starts at the top
 * This addresses the user requirement that all links to new pages start at the top
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use instant for immediate scroll on page load
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
